import Rest from './rest';

const RESOURCE = "appadminuser";

export default {

    filterUsers: function (params) {
        return Rest.get(RESOURCE, {params})
    },
    getUser: function (userId) {
        return Rest.get(`${RESOURCE}/${userId}`);
    },
    addUser: function (data) {
        return Rest.post(RESOURCE, data);
    },
    updateUser: function (userId, data) {
        return Rest.put(`${RESOURCE}/${userId}`, data);
    },
    toggleUserState: function (userId, status) {
        return Rest.patch(`${RESOURCE}/${userId}`, null, {params: {status}});
    }
};



// WEBPACK FOOTER //
// ./src/services/AppAdminUserService.js